import moment from "moment";

export const hasLicenseExpired = (date: string) => {
    const today = moment().startOf("day");
    const expiresAt = moment(date).startOf("day");

    return expiresAt.isBefore(today) || expiresAt.isSame(today);
};
